import LabradorFront from '@/components/post-type/Front';
import { useAppState } from 'lib/hooks/useAppState';

const HantFront: typeof LabradorFront = (props) => {
  const [{ publishedUrl, type }] = useAppState();

  const isIndexPage = publishedUrl && ['/index'].includes(publishedUrl);
  const isArticlePage = type === 'article';

  const withBackgroundColor = Boolean(isIndexPage || isArticlePage);

  return <LabradorFront data-opaque={withBackgroundColor ? '' : undefined} {...props} />;
};

export default HantFront;
